// constanst
import {
    SUB_PRODUCT_NAME,
    SegmentEventNameTypes,
} from 'utils/segment/constants';

// helpers
import {
    pageEvent,
    trackEvent,
    waitForAnalyticsLoad,
} from '@acko-tech/building-blocks.ui.acko-analytics';
import { getProduct } from 'utils/helpers';

const sendSegmentEvent = (
    eventNameType: SegmentEventNameTypes,
    eventData: any,
    additionalData: any
) => {
    const { userDetails, isMobile } = additionalData;
    const product = getProduct(userDetails?.partner_id);
    const props = {
        product,
        sub_product_name: SUB_PRODUCT_NAME,
        email: !!userDetails?.email ? userDetails?.email : undefined,
        phone: !!userDetails?.phone ? userDetails?.phone : undefined,
        name: !!userDetails?.name ? userDetails?.name : undefined,
        partner: !!userDetails?.partner_id
            ? userDetails?.partner_id
            : undefined,
        page_url: window?.location?.href,
        referrer: document?.referrer,
        platform: isMobile ? 'mweb' : 'web',
        device: navigator?.userAgent,
        ...eventData,
    };

    if (eventNameType === SegmentEventNameTypes.VIEW)
        waitForAnalyticsLoad().then(() => pageEvent(eventNameType, props));
    if (
        eventNameType === SegmentEventNameTypes.ACTION ||
        eventNameType === SegmentEventNameTypes.EXCEPTION
    )
        trackEvent(eventNameType, props);
};

export default sendSegmentEvent;
